export function parseCrawlSearchFromSearchParams(
  searchParams: URLSearchParams,
): string {
  return searchParams.get('search')?.trim() ?? '';
}

export function buildCrawlSearchParams({
  searchInput,
}: {
  searchInput: string;
}): URLSearchParams {
  const params = new URLSearchParams();
  const trimmedSearch = searchInput.trim();
  if (trimmedSearch !== '') {
    params.set('search', trimmedSearch);
  }
  return params;
}
